import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = [ "grid"]

  getPagination(event) {
    const button = $(event.currentTarget);
    let _this = this,
        url = "",
        ord = null,
        cnt = null,
        col = null,
        c = null,
        s = null,
        f = null,
        t = null,
        pg = 1;

    if (event) {
      url = event.currentTarget.dataset.url;
      ord = event.currentTarget.dataset.ord;
      cnt = event.currentTarget.dataset.cnt;
      col = event.currentTarget.dataset.col;

      if (event.currentTarget.dataset.c != undefined)
        c = stringOrArray(event.currentTarget.dataset.c);
      
      s = event.currentTarget.dataset.s;
      f = event.currentTarget.dataset.f;
      t = event.currentTarget.dataset.t;
      pg = event.currentTarget.dataset.pg;
    }
    

    if (url.length > 0 && (pg < 2 || button.hasClass("loading") == false)) {
      button.addClass("loading");
      $.get( url, {
        ord: ord,
        cnt: cnt,
        col: col,
        c: c,
        s: s,
        f: f,
        t: t,
        pg: pg,
        pagination: true,
      })
      .done(function( data, _status, xhr ) {
        if (data.length > 1) {

          let frag = document.createRange().createContextualFragment(data);
          _this.gridTarget.append(frag);

          button.attr("data-pg", parseInt(pg) + 1);
        } else {
          button.remove();
        }
        if (xhr.getResponseHeader("X-Has-More") === "false") button.remove();
        button.filter(":not([autoload])").addClass("autoload");
        button.removeClass("loading");
      }).fail(function() {
        button.removeClass("loading");
      });
      
    }
  }

}

function stringOrArray(input) {
  if (typeof input === "string") {
    try {
      const parsed = JSON.parse(input);
      return Array.isArray(parsed) ? parsed : input;
    } catch {
      return input;
    }
  }

  if (Array.isArray(input)) return input;

  if (input == null) return [];

  return [input];
}
